const copyToClipboard = (data: string) => {
  return new Promise((resolve, reject) => {
    navigator.clipboard.writeText(data).then(resolve, reject);
  });
};

export default copyToClipboard;
